module.exports = __webpack_public_path__ + "img/update.54acc18b.png";